
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomatherancab() {



    const cardData =
    {
        keyword: 'Pune to Matheran Cab',
        heading: 'Meghana Cab : Pune to Matheran Cab',
        headingDescription: 'Meghana Cab offers Pune to Matheran Cab services, providing a safe, scenic, and hassle-free ride to one of Maharashtra’s most beautiful hill stations. Whether you are planning a weekend getaway, a family trip, or a romantic escape, our comfortable cabs and skilled drivers ensure a smooth journey up to the base of Matheran. Enjoy affordable pricing, timely pickups, and 24/7 customer support. Book your Pune to Matheran Cab with Meghana Cab and travel in comfort before switching to the toy train or walk to this eco-friendly paradise.',


        top: 'Top Places to Visit in Matheran with Meghana Cab',

"topPlaces": [
  {
    "title": "Panorama Point",
    "description": "One of the most scenic viewpoints in Matheran, Panorama Point offers breathtaking 360-degree views of the Western Ghats, lush valleys, and even distant glimpses of Neral and Mumbai on clear days. It's ideal for sunrise and sunset watchers, especially after a refreshing morning trek."
  },
  {
    "title": "Louisa Point",
    "description": "Louisa Point is popular for its panoramic views of the surrounding hills, waterfalls during monsoon, and ruins of Prabal Fort in the distance. It is a must-visit for nature lovers and photographers looking to capture the essence of the Sahyadris."
  },
  {
    "title": "Echo Point",
    "description": "True to its name, Echo Point is famous for the echo phenomenon and scenic surroundings. It’s a fun stop for visitors and also offers splendid views of the valleys below. During the monsoon, the misty ambiance adds to its charm."
  },
  {
    "title": "Charlotte Lake",
    "description": "This serene lake serves as the main source of drinking water for Matheran and is surrounded by dense forest. It’s a peaceful spot for picnics, birdwatching, and nature walks. Nearby attractions like Pisarnath Temple and Echo Point are accessible from here."
  },
  {
    "title": "One Tree Hill Point",
    "description": "A unique viewpoint known for a solitary tree standing on the hill’s crest, One Tree Hill offers a quiet and scenic trek through shaded trails. It provides excellent views of the deep valleys and is perfect for those seeking solitude."
  },
  {
    "title": "Alexander Point",
    "description": "This point offers stunning views of the Palasdari Lake, Garbut Point, and Rambaug Point. Less crowded compared to others, it’s a peaceful location with panoramic scenes, especially beautiful during sunrise hours."
  },
  {
    "title": "Honeymoon Hill and Sunset Point",
    "description": "These twin points are close to each other and are well-known for their romantic setting and clear views of the setting sun over the Western Ghats. They are often included in guided horse-riding tours across Matheran."
  },
  {
    "title": "Porcupine Point (Sunset Point)",
    "description": "Also referred to as Sunset Point, it offers a dramatic view of the sun setting behind hills and forests. The spot is surrounded by dense greenery and provides a peaceful place to end the day in Matheran."
  },
  {
    "title": "Matheran Toy Train",
    "description": "The heritage narrow-gauge train journey between Neral and Matheran is a major attraction, offering a nostalgic ride through forests, tunnels, and mountain curves. The train is recognized as a UNESCO World Heritage candidate and is a unique way to reach the hill station."
  },
  {
    "title": "Market Street",
    "description": "Matheran’s central bazaar is a car-free shopping lane where visitors can explore local handicrafts, leather goods, chikki, footwear, and souvenirs. It’s also dotted with heritage hotels, small eateries, and cafes that preserve the colonial charm of the town."
  }
],

"services": [
    {
        "name": "Cab from Pune to Matheran",
        "description": "Travel comfortably from Pune to Matheran with Meghana Cab’s reliable taxi services. Enjoy a hassle-free journey through scenic routes in well-maintained vehicles driven by experienced chauffeurs."
    },
    {
        "name": "One Way Pune to Matheran Taxi",
        "description": "Book an affordable one-way taxi from Pune to Matheran with Meghana Cab. Perfect for quick trips, family visits, or solo travel, our one-way service ensures convenience without return trip charges."
    },
    {
        "name": "Round Trip Matheran Cab from Pune",
        "description": "Plan a weekend getaway with Meghana Cab’s round trip service from Pune to Matheran. Benefit from affordable pricing, timely pick-up and drop-off, and comfortable vehicles for your scenic mountain trip."
    },
    {
        "name": "Pune to Matheran Travel by Car",
        "description": "Experience personalized road travel from Pune to Matheran by car with Meghana Cab. Our flexible schedules allow you to stop and explore along the way, making your journey enjoyable and relaxed."
    },
    {
        "name": "Affordable Cab to Matheran from Pune",
        "description": "Get budget-friendly cab services from Pune to Matheran without compromising on comfort or safety. Meghana Cab offers competitive fares and quality vehicles for your travel needs."
    },
    {
        "name": "AC Cab Hire Pune to Matheran",
        "description": "Beat the heat with Meghana Cab’s air-conditioned vehicle options from Pune to Matheran. Our AC cabs provide a cool and refreshing travel experience, ideal for warm weather journeys."
    },
    {
        "name": "Online Taxi Booking Pune to Matheran",
        "description": "Book your Pune to Matheran taxi online instantly with Meghana Cab. Enjoy real-time availability, easy payment options, and instant booking confirmation for a smooth user experience."
    },
    {
        "name": "Pune to Matheran Day Tour Cab",
        "description": "Looking for a day trip to Matheran? Meghana Cab offers special day tour packages with flexible pick-up and drop timings, allowing you to explore Matheran’s beautiful viewpoints and attractions stress-free."
    },
    {
        "name": "Sedan/SUV Cab Pune to Matheran",
        "description": "Choose from our fleet of comfortable sedans and spacious SUVs for your Pune to Matheran trip. Whether traveling solo, with family, or in a group, Meghana Cab has the perfect vehicle to suit your needs."
    },
    {
        "name": "Book Private Taxi Pune to Matheran",
        "description": "Enjoy privacy and personalized service with Meghana Cab’s private taxi hire for Pune to Matheran. Our dedicated drivers ensure door-to-door service and a safe, comfortable ride."
    },
    {
        "name": "Matheran Weekend Trip Cab Pune",
        "description": "Plan your weekend escape to Matheran effortlessly with Meghana Cab. Our reliable cabs are available 24/7, making your trip convenient, affordable, and enjoyable."
    },
    {
        "name": "24/7 Cabs Pune to Matheran",
        "description": "Need a cab any time of the day? Meghana Cab offers 24/7 taxi services from Pune to Matheran, ensuring you never miss your trip no matter the hour."
    },
    {
        "name": "Budget Pune to Matheran Cab Fare",
        "description": "Travel smart with Meghana Cab’s budget-friendly fare options for Pune to Matheran routes. Get value for money with no hidden charges and quality service."
    },
    {
        "name": "Local Cab Service for Matheran Trip",
        "description": "Looking for a local cab around Matheran? Meghana Cab provides local taxi services to help you explore the hills and local attractions with ease and comfort."
    },
    {
        "name": "Car Rental Pune to Matheran",
        "description": "Rent a car from Pune to Matheran with Meghana Cab for flexible, self-driven travel. Choose from a range of vehicles including sedans and SUVs to suit your preferences."
    }
],

"tableData": [
    ["Cab from Pune to Matheran", "One Way Pune to Matheran Taxi"],
    ["Round Trip Matheran Cab from Pune", "Pune to Matheran Travel by Car"],
    ["Affordable Cab to Matheran from Pune", "AC Cab Hire Pune to Matheran"],
    ["Online Taxi Booking Pune to Matheran", "Pune to Matheran Day Tour Cab"],
    ["Sedan/SUV Cab Pune to Matheran", "Book Private Taxi Pune to Matheran"],
    ["Matheran Weekend Trip Cab Pune", "24/7 Cabs Pune to Matheran"],
    ["Budget Pune to Matheran Cab Fare", "Local Cab Service for Matheran Trip"],
    ["Car Rental Pune to Matheran", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Matheran Cab Service",
        "WhyChoosedescription": "Meghana Cab offers hassle-free and comfortable cab services from Pune to Matheran, making your hill station trip smooth and enjoyable with reliable transportation."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Mountain Roads",
        "WhyChoosedescription": "Our skilled drivers know the winding routes to Matheran well, ensuring a safe and pleasant journey through the scenic hills."
    },
    {
        "WhyChooseheading": "Flexible Pickup and Drop-off Options",
        "WhyChoosedescription": "Whether you need pick-up from your home, hotel, or office in Pune, Meghana Cab provides convenient and timely drop-offs at your desired location in Matheran."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in comfort with our sanitized, air-conditioned, and well-maintained cars equipped for hill travel."
    },
    {
        "WhyChooseheading": "Affordable Pricing with Transparent Rates",
        "WhyChoosedescription": "Enjoy competitive and clear pricing for your Pune to Matheran cab without any hidden charges, allowing you to plan your trip budget confidently."
    },
    {
        "WhyChooseheading": "Customizable Itinerary with Stopovers",
        "WhyChoosedescription": "Want to stop en route for sightseeing or refreshments? We offer customizable travel plans to make your journey even more enjoyable."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Our Pune to Matheran cab service is available round-the-clock, accommodating early morning departures and late returns as per your schedule."
    },
    {
        "WhyChooseheading": "Easy Booking and Support",
        "WhyChoosedescription": "Book your cab quickly and conveniently through our website, app, or customer service, with dedicated support for all your travel needs."
    }
]

































    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Matheran with Meghana Cab?",
        answer: "You can easily book a Pune to Matheran cab by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "What types of vehicles are available for Pune to Matheran trips?",
        answer: "We offer sedans, SUVs, and tempo travellers suitable for the scenic trip from Pune to Matheran."
    },
    {
        question: "Are your drivers experienced with routes to Matheran?",
        answer: "Yes, our drivers are familiar with the best routes to Matheran ensuring a safe and comfortable journey."
    },
    {
        question: "Can I book a one-way or round trip cab from Pune to Matheran?",
        answer: "Yes, we provide both one-way and round-trip cab services according to your travel needs."
    },
    {
        question: "What is included in the Pune to Matheran cab fare?",
        answer: "The fare includes driver charges, vehicle maintenance, and fuel. Additional charges like tolls or parking may apply."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Matheran bookings?",
        answer: "Yes, our services operate 24/7 to accommodate your booking requirements."
    },
    {
        question: "Can I hire a cab for a group traveling to Matheran?",
        answer: "Yes, we offer various vehicle options including tempo travellers for larger groups."
    },
    {
        question: "Are the vehicles clean and sanitized for travel?",
        answer: "All vehicles are regularly cleaned and sanitized for your safety and comfort."
    },
    {
        question: "What payment methods do you accept for Pune to Matheran cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Matheran cab service?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Matheran cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Matheran cab service from Meghana Cab was excellent. The driver was punctual and the vehicle comfortable.”',
    },
    {
        name: 'Ms. Anjali Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I had a wonderful trip from Pune to Matheran with Meghana Cab. The booking was smooth and the driver friendly.”',
    },
];


























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Matheran Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-matheran-cab.jpg",
  "description": "Book Pune to Matheran cab services with Meghana Cabs for affordable, comfortable, and reliable travel. Options include one way, round trip, AC sedans, SUVs, and private taxis.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-matheran-cab"
  }
};







    return (
        <div>



<Helmet>
  <title>Pune to Matheran Cab | Affordable & Reliable Taxi Service</title>
  <meta 
    name="description" 
    content="Book Pune to Matheran cab services with Meghana Cabs for affordable, comfortable, and reliable travel. Options include one way, round trip, AC sedans, SUVs, and private taxis." 
  />
  <meta 
    name="keywords" 
    content="Cab from Pune to Matheran, One Way Pune to Matheran Taxi, Round Trip Matheran Cab from Pune, Pune to Matheran Travel by Car, Affordable Cab to Matheran from Pune, AC Cab Hire Pune to Matheran, Online Taxi Booking Pune to Matheran, Pune to Matheran Day Tour Cab, Sedan/SUV Cab Pune to Matheran, Book Private Taxi Pune to Matheran, Matheran Weekend Trip Cab Pune, 24/7 Cabs Pune to Matheran, Budget Pune to Matheran Cab Fare, Local Cab Service for Matheran Trip, Car Rental Pune to Matheran" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/22.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomatherancab;